// randomItem.js

import seedrandom from 'seedrandom';

let random = Math.random;

// Function to randomly select an item from a list
export function getRandomItem(arr) {
    const randomIndex = Math.floor(random() * arr.length);
    return arr[randomIndex];
}

export function getRandomItemWeighted(arr, weights) {
    // Check that weights sum to 1.0 (with a small epsilon for floating point)
    const sum = weights.reduce((a, b) => a + b, 0);
    if (Math.abs(sum - 1.0) > 1e-8) {
        throw new Error(`Weights must sum to 1.0 (got ${sum})`);
    }

    const roll = random();
    let cumulative = 0;
    for (let i = 0; i < arr.length; i++) {
        cumulative += weights[i];
        if (roll < cumulative) {
            return arr[i];
        }
    }
    // Fallback in case of floating point error
    return arr[arr.length - 1];
}

export function seedRandomItem(seed) {
    random = seedrandom(seed);
}

export function getRandomNumberInRange(min, max) {
    return Math.floor(random() * (max - min + 1)) + min;
}

export default getRandomItem;
